import React, { Component } from "react";
//PrimeReact Components
import * as pr from "../../common/PrimeComponents";
//Common Functions
import { api } from "../../common/CloudService/ApiPromisify";
import { CloudService } from "../../common/CloudService/ClientLibsReference";
import { LoadScreen } from "../Common/LoadScreen";
import * as c from "../../common/config/AppConstants";
import * as fo from "../../common/FormatFunctions";

export class GoodsComplete extends Component {
  constructor() {
    super();
    this.state = {
      //Loading
      loaded: false,
      editLoaded: true,
      //Display
      goodsSelected: false,
      goodsEdited: false,
      goodsAdded: false,
      goodsDeleted: false,
      itemsDisplay: false,
      goodsItemSelected: false,
      goodsItemEdited: false,
      goodsItemAdded: false,
      goodsItemDeleted: false,
      //Details
      goodsList: [],
      selectedGoods: "",
      goodsClientDetails: "",
      goodsClientDetailsAddressLine1: "",
      goodsClientDetailsAddressLine2: "",
      goodsClientDetailsBusinessName: "",
      goodsClientDetailsCity: "",
      goodsClientDetailsCodeTag: "",
      goodsClientDetailsCountryCode: "",
      goodsClientDetailsCurrency: "",
      goodsClientDetailsCurrencyDecimalPlaces: "",
      goodsClientDetailsCurrencySymbol: "",
      goodsClientDetailsDateCreated: "",
      goodsClientDetailsId: "",
      goodsClientDetailsLastUpdatedDateTime: "",
      goodsClientDetailsPostalZipCode: "",
      goodsClientDetailsTimezone: "",
      goodsClientDetailsType: "",
      goodsClientId: "",
      goodsCodeTag: "",
      goodsCollectedBy: "",
      goodsDateCreated: "",
      goodsDateOrderReceived: "",
      goodsDateOrderReceivedToDisplay: "",
      goodsDeliveryDockets: "",
      goodsDeliveryDriverName: "",
      goodsDeliveryDriverSignature: "",
      goodsDnumber: "",
      goodsId: "",
      goodsLastUpdatedDateTime: "",
      goodsOrderItems: "",
      goodsPdfURLs: "",
      goodsQuantityRemaining: "",
      goodsSoNumber: "",
      goodsStatus: "",
      goodsTotalQuantity: "",
      goodsType: "",
      goodsUserId: "",
      //Edit Details
      editedGoodsClientDetailsAddressLine1: "",
      editedGoodsClientDetailsAddressLine2: "",
      editedGoodsClientDetailsBusinessName: "",
      editedGoodsClientDetailsCity: "",
      editedGoodsClientDetailsCountryCode: "",
      editedGoodsClientDetailsCurrency: "",
      editedGoodsClientDetailsCurrencyDecimalPlaces: "",
      editedGoodsClientDetailsCurrencySymbol: "",
      editedGoodsClientDetailsId: "",
      editedGoodsClientDetailsPostalZipCode: "",
      editedGoodsClientDetailsTimezone: "",
      editedGoodsClientDetailsType: "",
      editedGoodsClientId: "",
      editedGoodsCollectedBy: "",
      editedGoodsDateOrderReceived: "",
      editedGoodsDeliveryDockets: "",
      editedGoodsDeliveryDriverName: "",
      editedGoodsDeliveryDriverSignature: "",
      editedGoodsDnumber: "",
      editedGoodsOrderItems: "",
      editedGoodsQuantityRemaining: "",
      editedGoodsSoNumber: "",
      editedGoodsStatus: "",
      editedGoodsTotalQuantity: "",
      editedGoodsType: "",
      editedGoodsUserId: "",
      //Item Details
      selectedGoodsItem: "",
      goodsItemClientId: "",
      goodsItemCodeTag: "",
      goodsItemDateCreated: "",
      goodsItemDescription: "",
      goodsItemId: "",
      goodsItemImageURLs: "",
      goodsItemLastUpdatedDateTime: "",
      goodsItemLongDescription: "",
      goodsItemOrderId: "",
      goodsItemQuantity: "",
      goodsItemQuantityRemaining: "",
      goodsItemStatus: "",
      goodsItemStockCode: "",
      goodsItemType: "",
      goodsItemUserId: "",
      //Edit Item Details
      editedGoodsItemClientId: "",
      editedGoodsItemDescription: "",
      editedGoodsItemImageURLs: "",
      editedGoodsItemLongDescription: "",
      editedGoodsItemQuantity: "",
      editedGoodsItemQuantityRemaining: "",
      editedGoodsItemStatus: "",
      editedGoodsItemStockCode: "",
      editedGoodsItemType: "",
      editedGoodsItemUserId: "",
      //Options
      clientList: [],
      clientOptions: [],
      stockCodeList: [],
      stockCodeOptions: [],
      //Other
      dateFormat: "dd/mm/yy",
      showImages: false,
      showItemImages: false
    };
  }

  componentDidMount = () => {
    this.getClients();
    this.getStockCodes();
    this.getGoods();
  };

  getClients = async () => {
    let businessRequest = new CloudService.BusinessRequest();
    businessRequest.codeTag = localStorage.getItem("codeTag");
    businessRequest.userId = localStorage.getItem("userId");
    businessRequest.type = "Client";

    await api("businessApiV1BusinesslistByType", businessRequest).then(res => {
      if (res.data.businesses) {
        res.data.businesses.forEach(e => {
          if (e.lastUpdatedDateTime) {
            e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
          }
          if (e.dateCreated) {
            e.dateCreated = e.dateCreated.toJSON();
          }
        });
      }

      let businessResponse = CloudService.BusinessResponse.constructFromObject(
        res.data
      );
      console.log(businessResponse);

      if (businessResponse.errorCode === 0) {
        this.setState(
          {
            clientList: businessResponse.businesses
          },
          () => {
            this.clientsToOptions();
          }
        );
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error occured retrieving clients, please refresh and try again",
          life: 3000
        });
      }
    });
  };

  clientsToOptions = () => {
    let clientArray = [];

    if (this.state.clientList && this.state.clientList.length) {
      this.state.clientList.forEach(e => {
        clientArray.push({
          label: e.businessName,
          value: e.id
        });
      });
    }

    this.setState({ clientOptions: clientArray });
  };

  getStockCodes = async () => {
    let stockRequest = new CloudService.StockRequest();
    stockRequest.codeTag = localStorage.getItem("codeTag");
    stockRequest.userId = localStorage.getItem("userId");

    await api("stockApiV1StockGetByCodeTag", stockRequest).then(res => {
      if (res.data.stockList) {
        res.data.stockList.forEach(e => {
          if (e.lastUpdatedDateTime) {
            e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
          }
        });
      }

      let stockResponse = CloudService.StockResponse.constructFromObject(
        res.data
      );
      console.log(stockResponse);

      if (stockResponse.errorCode === 0) {
        this.setState(
          {
            stockList: stockResponse.stockList
          },
          () => {
            this.stockCodesToOptions();
          }
        );
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error occured retrieving the stock codes, please refresh and try again",
          life: 3000
        });
      }
    });
  };

  stockCodesToOptions = () => {
    let stockCodeArray = [];

    if (this.state.stockList && this.state.stockList.length) {
      this.state.stockList.forEach(e => {
        stockCodeArray.push({
          label: e.stockCode,
          value: e.stockCode
        });
      });
    }

    this.setState({ stockCodeOptions: stockCodeArray });
  };

  getGoods = async () => {
    let orderRequest = new CloudService.OrderRequestLogistics();
    orderRequest.codeTag = localStorage.getItem("codeTag");
    orderRequest.userId = localStorage.getItem("userId");
    orderRequest.status = "UPDATED_ON_XERO";

    await api("orderApiV1OrderGetByStatus", orderRequest).then(res => {
      if (res.data.orderList) {
        res.data.orderList.forEach(e => {
          if (e.lastUpdatedDateTime) {
            e.lastUpdatedDateTime = e.lastUpdatedDateTime.toJSON();
          }
          if (e.dateCreated) {
            e.dateCreated = e.dateCreated.toJSON();
          }
          if (e.dateOrderReceived) {
            e.dateOrderReceived = e.dateOrderReceived.toJSON();
          }
          if (e.orderItems) {
            e.orderItems.forEach(f => {
              f.lastUpdatedDateTime = f.lastUpdatedDateTime.toJSON();
            });
          }
        });
      }

      let orderResponse = CloudService.OrderResponseLogistics.constructFromObject(
        res.data
      );
      console.log(orderResponse);

      if (orderResponse.errorCode === 0) {
        this.setState(
          {
            goodsList: orderResponse.orderList
          },
          () => {
            console.log(this.state.goodsList);
            this.reselectGoods();
          }
        );
      } else {
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail:
            "An error occured retrieving goods, please refresh and try again",
          life: 3000
        });
      }
    });

    this.setState({ loaded: true, editLoaded: true });
  };

  updateGoods = async () => {
    this.setState({ editLoaded: false });

    let orderRequest = new CloudService.OrderRequestLogistics();
    orderRequest.codeTag = localStorage.getItem("codeTag");
    orderRequest.userId = localStorage.getItem("userId");
    orderRequest.id = this.state.goodsId;
    orderRequest.lastUpdatedDateTime = this.state.goodsLastUpdatedDateTime;
    orderRequest.clientId = this.state.editedGoodsClientId;
    orderRequest.dnumber = this.state.editedGoodsDnumber;
    orderRequest.dateOrderReceived = this.state.editedGoodsDateOrderReceived;
    orderRequest.collectedBy = this.state.editedGoodsCollectedBy;
    orderRequest.deliveryDriverName = this.state.editedGoodsDeliveryDriverName;
    orderRequest.soNumber = this.state.editedGoodsSoNumber;
    orderRequest.type = this.state.editedGoodsType;
    orderRequest.status = this.state.editedGoodsStatus;

    await api("orderApiV1OrderUpdate", orderRequest).then(res => {
      if (res.data.lastUpdatedDateTime) {
        res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
      }

      let orderResponse = CloudService.OrderResponseLogistics.constructFromObject(
        res.data
      );
      console.log(orderResponse);

      if (orderResponse.errorCode === 0) {
        this.setState({
          goodsEdited: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Goods successfully updated",
          life: 3000
        });
        let typeOfUpdate = 1;
        this.updateGoodsList(orderResponse, typeOfUpdate);
      } else {
        this.setState({ editLoaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured updating the goods, please try again",
          life: 3000
        });
      }
    });
  };

  addGoods = async () => {
    this.setState({ editLoaded: false });

    let orderRequest = new CloudService.OrderRequestLogistics();
    orderRequest.codeTag = localStorage.getItem("codeTag");
    orderRequest.userId = localStorage.getItem("userId");
    orderRequest.clientId = this.state.editedGoodsClientId;
    orderRequest.dateOrderReceived = this.state.editedGoodsDateOrderReceived;
    orderRequest.collectedBy = this.state.editedGoodsCollectedBy;
    orderRequest.deliveryDriverName = this.state.editedGoodsDeliveryDriverName;
    orderRequest.soNumber = this.state.editedGoodsSoNumber;
    orderRequest.type = this.state.editedGoodsType;
    orderRequest.status = this.state.editedGoodsStatus;

    await api("orderApiV1OrderCreate", orderRequest).then(res => {
      if (res.data.lastUpdatedDateTime) {
        res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
      }

      let orderResponse = CloudService.OrderResponseLogistics.constructFromObject(
        res.data
      );
      console.log(orderResponse);

      if (orderResponse.errorCode === 0) {
        this.setState({
          orderEdited: false,
          orderAdded: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Goods successfully created",
          life: 3000
        });
        let typeOfUpdate = 2;
        this.updateGoodsList(orderResponse, typeOfUpdate);
      } else {
        this.setState({ editLoaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured creating the goods, please try again",
          life: 3000
        });
      }
    });
  };

  deleteGoods = async () => {
    this.setState({ loaded: false });

    let orderRequest = new CloudService.OrderRequestLogistics();
    orderRequest.codeTag = localStorage.getItem("clientId");
    orderRequest.userId = localStorage.getItem("userId");
    orderRequest.id = this.state.goodsId;
    orderRequest.lastUpdatedDateTime = this.state.goodsLastUpdatedDateTime;

    await api("orderApiV1OrderDelete", orderRequest).then(res => {
      let orderResponse = CloudService.OrderResponseLogistics.constructFromObject(
        res.data
      );
      console.log(orderResponse);

      if (orderResponse.errorCode === 0) {
        this.setState({
          goodsSelected: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Goods successfully deleted",
          life: 3000
        });
        let typeOfUpdate = 3;
        this.updateGoodsList(orderResponse, typeOfUpdate);
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured deleting the goods, please try again",
          life: 3000
        });
      }
    });
  };

  updateGoodsList = (apiResponse, type) => {
    let goodsList = this.state.goodsList;
    let i = 0;

    if (type === 2) {
      goodsList.push({
        id: apiResponse.id,
        lastUpdatedDateTime: apiResponse.lastUpdatedDateTime,
        clientDetails: apiResponse.clientDetails,
        clientId: this.state.editedGoodsClientId,
        dnumber: apiResponse.dnumber,
        dateOrderReceived: this.state.editedGoodsDateOrderReceived,
        dateOrderReceivedToDisplay: apiResponse.dateOrderReceivedToDisplay,
        collectedBy: this.state.editedGoodsCollectedBy,
        deliveryDriverName: this.state.editedGoodsDeliveryDriverName,
        soNumber: this.state.editedGoodsSoNumber,
        type: this.state.editedGoodsType,
        status: this.state.editedGoodsStatus,
        orderItems: []
      });
    } else {
      this.state.goodsList.forEach(e => {
        if (apiResponse.id === e.id || this.state.goodsId === e.id) {
          if (type === 1) {
            goodsList[i].lastUpdatedDateTime = apiResponse.lastUpdatedDateTime;
            goodsList[i].clientId = this.state.editedGoodsClientId;
            goodsList[i].dnumber = this.state.editedGoodsDnumber;
            goodsList[
              i
            ].dateOrderReceived = this.state.editedGoodsDateOrderReceived;
            goodsList[i].collectedBy = this.state.editedGoodsCollectedBy;
            goodsList[
              i
            ].deliveryDriverName = this.state.editedGoodsDeliveryDriverName;
            goodsList[i].soNumber = this.state.editedGoodsSoNumber;
            goodsList[i].type = this.state.editedGoodsType;
            goodsList[i].status = this.state.editedGoodsStatus;
          }
          if (type === 3) {
            goodsList.splice(i, 1);
          }
        }
        i++;
      });
    }

    this.setState(
      { goodsList: goodsList, loaded: true, editLoaded: true },
      () => {
        console.log(this.state.goodsList);
        this.reselectGoods();
      }
    );
  };

  selectGoods = data => {
    this.setState(
      {
        selectedGoods: data,
        goodsClientDetails: data.clientDetails,
        goodsClientId: data.clientId,
        goodsCodeTag: data.codeTag,
        goodsCollectedBy: data.collectedBy,
        goodsDateCreated: data.dateCreated,
        goodsDateOrderReceived: data.dateOrderReceived,
        goodsDateOrderReceivedToDisplay: data.dateOrderReceivedToDisplay,
        goodsDeliveryDockets: data.deliveryDockets,
        goodsDeliveryDriverName: data.deliveryDriverName,
        goodsDeliveryDriverSignature: data.deliveryDriverSignature,
        goodsDnumber: data.dnumber,
        goodsId: data.id,
        goodsLastUpdatedDateTime: data.lastUpdatedDateTime,
        goodsOrderItems: data.orderItems,
        goodsPdfURLs: data.pdfURLs,
        goodsQuantityRemaining: data.quantityRemaining,
        goodsSoNumber: data.soNumber,
        goodsStatus: data.status,
        goodsTotalQuantity: data.totalQuantity,
        goodsType: data.type,
        goodsUserId: data.userId
      },
      () => {
        if (data.clientDetails) {
          this.setState({
            goodsClientDetailsAddressLine1: data.clientDetails.addressLine1,
            goodsClientDetailsAddressLine2: data.clientDetails.addressLine2,
            goodsClientDetailsBusinessName: data.clientDetails.businessName,
            goodsClientDetailsCity: data.clientDetails.city,
            goodsClientDetailsCodeTag: data.clientDetails.codeTag,
            goodsClientDetailsCountryCode: data.clientDetails.countryCode,
            goodsClientDetailsCurrency: data.clientDetails.currency,
            goodsClientDetailsCurrencyDecimalPlaces:
              data.clientDetails.currencyDecimalPlaces,
            goodsClientDetailsCurrencySymbol: data.clientDetails.currencySymbol,
            goodsClientDetailsDateCreated: data.clientDetails.dateCreated,
            goodsClientDetailsId: data.clientDetails.id,
            goodsClientDetailsLastUpdatedDateTime:
              data.clientDetails.lastUpdatedDateTime,
            goodsClientDetailsPostalZipCode: data.clientDetails.postalZipCode,
            goodsClientDetailsTimezone: data.clientDetails.timezone,
            goodsClientDetailsType: data.clientDetails.type
          });
        } else {
          this.setState({
            goodsClientDetailsAddressLine1: "",
            goodsClientDetailsAddressLine2: "",
            goodsClientDetailsBusinessName: "",
            goodsClientDetailsCity: "",
            goodsClientDetailsCodeTag: "",
            goodsClientDetailsCountryCode: "",
            goodsClientDetailsCurrency: "",
            goodsClientDetailsCurrencyDecimalPlaces: "",
            goodsClientDetailsCurrencySymbol: "",
            goodsClientDetailsDateCreated: "",
            goodsClientDetailsId: "",
            goodsClientDetailsLastUpdatedDateTime: "",
            goodsClientDetailsPostalZipCode: "",
            goodsClientDetailsTimezone: "",
            goodsClientDetailsType: ""
          });
        }

        console.log(this.state.selectedGoods);
      }
    );
  };

  editGoods = () => {
    if (this.state.goodsAdded === true) {
      this.setState({
        editedGoodsClientDetailsAddressLine1: "",
        editedGoodsClientDetailsAddressLine2: "",
        editedGoodsClientDetailsBusinessName: "",
        editedGoodsClientDetailsCity: "",
        editedGoodsClientDetailsCountryCode: "",
        editedGoodsClientDetailsCurrency: "",
        editedGoodsClientDetailsCurrencyDecimalPlaces: "",
        editedGoodsClientDetailsCurrencySymbol: "",
        editedGoodsClientDetailsId: "",
        editedGoodsClientDetailsPostalZipCode: "",
        editedGoodsClientDetailsTimezone: "",
        editedGoodsClientDetailsType: "",
        editedGoodsClientId: "",
        editedGoodsCollectedBy: "",
        editedGoodsDateOrderReceived: "",
        editedGoodsDeliveryDockets: "",
        editedGoodsDeliveryDriverName: "",
        editedGoodsDeliveryDriverSignature: "",
        editedGoodsDnumber: "",
        editedGoodsOrderItems: "",
        editedGoodsQuantityRemaining: "",
        editedGoodsSoNumber: "",
        editedGoodsStatus: "",
        editedGoodsTotalQuantity: "",
        editedGoodsType: "",
        editedGoodsUserId: ""
      });
    } else {
      this.setState({
        editedGoodsClientDetailsAddressLine1: this.state
          .goodsClientDetailsAddressLine1,
        editedGoodsClientDetailsAddressLine2: this.state
          .goodsClientDetailsAddressLine2,
        editedGoodsClientDetailsBusinessName: this.state
          .goodsClientDetailsBusinessName,
        editedGoodsClientDetailsCity: this.state.goodsClientDetailsCity,
        editedGoodsClientDetailsCountryCode: this.state
          .goodsClientDetailsCountryCode,
        editedGoodsClientDetailsCurrency: this.state.goodsClientDetailsCurrency,
        editedGoodsClientDetailsCurrencyDecimalPlaces: this.state
          .goodsClientDetailsCurrencyDecimalPlaces,
        editedGoodsClientDetailsCurrencySymbol: this.state
          .goodsClientDetailsCurrencySymbol,
        editedGoodsClientDetailsId: this.state.goodsClientDetailsId,
        editedGoodsClientDetailsPostalZipCode: this.state
          .goodsClientDetailsPostalZipCode,
        editedGoodsClientDetailsTimezone: this.state.goodsClientDetailsTimezone,
        editedGoodsClientDetailsType: this.state.goodsClientDetailsType,
        editedGoodsClientId: this.state.goodsClientId,
        editedGoodsCollectedBy: this.state.goodsCollectedBy,
        editedGoodsDateOrderReceived: this.state.goodsDateOrderReceived,
        editedGoodsDeliveryDockets: this.state.goodsDeliveryDockets,
        editedGoodsDeliveryDriverName: this.state.goodsDeliveryDriverName,
        editedGoodsDeliveryDriverSignature: this.state
          .goodsDeliveryDriverSignature,
        editedGoodsDnumber: this.state.goodsDnumber,
        editedGoodsOrderItems: this.state.goodsOrderItems,
        editedGoodsQuantityRemaining: this.state.goodsQuantityRemaining,
        editedGoodsSoNumber: this.state.goodsSoNumber,
        editedGoodsStatus: this.state.goodsStatus,
        editedGoodsTotalQuantity: this.state.goodsTotalQuantity,
        editedGoodsType: this.state.goodsType,
        editedGoodsUserId: this.state.goodsUserId
      });
    }
  };

  reselectGoods = () => {
    if (this.state.selectedGoods) {
      this.state.goodsList.forEach(e => {
        if (this.state.goodsId === e.id) {
          this.setState(
            {
              goodsSelected: true,
              goodsEdited: false,
              goodsAdded: false
            },
            () => {
              this.selectGoods(e);
            }
          );
        }
      });
    }
  };

  checkGoodsRequiredFields = () => {
    let disable = false;

    if (this.state.editedGoodsClientId) {
      disable = false;
    } else {
      disable = true;
    }

    return disable;
  };

  updateGoodsItem = async () => {
    this.setState({ editLoaded: false });

    let orderItemRequest = new CloudService.OrderItemRequestLogistics();
    orderItemRequest.codeTag = localStorage.getItem("codeTag");
    orderItemRequest.userId = localStorage.getItem("userId");
    orderItemRequest.orderId = this.state.goodsId;
    orderItemRequest.id = this.state.goodsItemId;
    orderItemRequest.lastUpdatedDateTime = this.state.goodsItemLastUpdatedDateTime;
    orderItemRequest.stockCode = this.state.editedGoodsItemStockCode;
    orderItemRequest.description = this.state.editedGoodsItemDescription;
    orderItemRequest.quantity = this.state.editedGoodsItemQuantity;
    orderItemRequest.longDescription = this.state.editedGoodsItemLongDescription;

    await api("orderItemApiV1OrderItemUpdate", orderItemRequest).then(res => {
      if (res.data.lastUpdatedDateTime) {
        res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
      }

      let orderItemResponse = CloudService.OrderItemResponseLogistics.constructFromObject(
        res.data
      );
      console.log(orderItemResponse);

      if (orderItemResponse.errorCode === 0) {
        this.setState({
          goodsItemEdited: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Item successfully updated",
          life: 3000
        });
        let typeOfUpdate = 1;
        this.updateGoodsItemList(orderItemResponse, typeOfUpdate);
      } else {
        this.setState({ editLoaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured updating the item, please try again",
          life: 3000
        });
      }
    });
  };

  addGoodsItem = async () => {
    this.setState({ editLoaded: false });

    let orderItemRequest = new CloudService.OrderItemRequestLogistics();
    orderItemRequest.codeTag = localStorage.getItem("codeTag");
    orderItemRequest.userId = localStorage.getItem("userId");
    orderItemRequest.orderId = this.state.goodsId;
    orderItemRequest.type = this.state.goodsType;
    orderItemRequest.clientId = this.state.goodsClientId;
    orderItemRequest.stockCode = this.state.editedGoodsItemStockCode;
    orderItemRequest.description = this.state.editedGoodsItemDescription;
    orderItemRequest.quantity = this.state.editedGoodsItemQuantity;
    orderItemRequest.longDescription = this.state.editedGoodsItemLongDescription;

    await api("orderItemApiV1OrderItemCreate", orderItemRequest).then(res => {
      if (res.data.lastUpdatedDateTime) {
        res.data.lastUpdatedDateTime = res.data.lastUpdatedDateTime.toJSON();
      }

      let orderItemResponse = CloudService.OrderItemResponseLogistics.constructFromObject(
        res.data
      );
      console.log(orderItemResponse);

      if (orderItemResponse.errorCode === 0) {
        this.setState({
          goodsItemEdited: false,
          goodsItemAdded: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Item successfully created",
          life: 3000
        });
        let typeOfUpdate = 2;
        this.updateGoodsItemList(orderItemResponse, typeOfUpdate);
      } else {
        this.setState({ editLoaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured creating the item, please try again",
          life: 3000
        });
      }
    });
  };

  deleteGoodsItem = async () => {
    this.setState({ loaded: false });

    let orderItemRequest = new CloudService.OrderItemRequestLogistics();
    orderItemRequest.codeTag = localStorage.getItem("clientId");
    orderItemRequest.userId = localStorage.getItem("userId");
    orderItemRequest.orderId = this.state.goodsId;
    orderItemRequest.id = this.state.goodsItemId;
    orderItemRequest.lastUpdatedDateTime = this.state.goodsItemLastUpdatedDateTime;

    await api("orderItemApiV1OrderItemDelete", orderItemRequest).then(res => {
      let orderItemResponse = CloudService.OrderItemResponseLogistics.constructFromObject(
        res.data
      );
      console.log(orderItemResponse);

      if (orderItemResponse.errorCode === 0) {
        this.setState({
          goodsItemSelected: false
        });
        this.growl.show({
          severity: "success",
          summary: "Success",
          detail: "Item successfully deleted",
          life: 3000
        });
        let typeOfUpdate = 3;
        this.updateGoodsItemList(orderItemResponse, typeOfUpdate);
      } else {
        this.setState({ loaded: true });
        this.growl.show({
          severity: "error",
          summary: "Error",
          detail: "An error occured deleting the item, please try again",
          life: 3000
        });
      }
    });
  };

  updateGoodsItemList = (apiResponse, type) => {
    let goodsOrderItems = this.state.goodsOrderItems;
    let i = 0;

    if (type === 2) {
      goodsOrderItems.push({
        id: apiResponse.id,
        lastUpdatedDateTime: apiResponse.lastUpdatedDateTime,
        stockCode: this.state.editedGoodsItemStockCode,
        description: this.state.editedGoodsItemDescription,
        quantity: this.state.editedGoodsItemQuantity,
        quantityRemaining: apiResponse.quantityRemaining,
        longDescription: this.state.editedGoodsItemLongDescription
      });
    } else {
      this.state.goodsOrderItems.forEach(e => {
        if (apiResponse.id === e.id || this.state.goodsItemId === e.id) {
          if (type === 1) {
            goodsOrderItems[i].lastUpdatedDateTime =
              apiResponse.lastUpdatedDateTime;
            goodsOrderItems[i].stockCode = this.state.editedGoodsItemStockCode;
            goodsOrderItems[
              i
            ].description = this.state.editedGoodsItemDescription;
            goodsOrderItems[i].quantity = this.state.editedGoodsItemQuantity;
            goodsOrderItems[i].quantityRemaining =
              apiResponse.quantityRemaining;
            goodsOrderItems[
              i
            ].longDescription = this.state.editedGoodsItemLongDescription;
          }
          if (type === 3) {
            goodsOrderItems.splice(i, 1);
          }
        }
        i++;
      });
    }

    let goodsList = this.state.goodsList;
    goodsList.orderItems = goodsOrderItems;
    this.setState(
      { goodsList: goodsList, loaded: true, editLoaded: true },
      () => {
        console.log(this.state.goodsList);
        this.reselectGoodsItem();
      }
    );
  };

  selectGoodsItem = data => {
    this.setState(
      {
        selectedGoodsItem: data,
        goodsItemClientId: data.clientId,
        goodsItemCodeTag: data.codeTag,
        goodsItemDateCreated: data.dateCreated,
        goodsItemDescription: data.description,
        goodsItemId: data.id,
        goodsItemImageURLs: data.imageURLs,
        goodsItemLastUpdatedDateTime: data.lastUpdatedDateTime,
        goodsItemLongDescription: data.longDescription,
        goodsItemOrderId: data.orderId,
        goodsItemQuantity: data.quantity,
        goodsItemQuantityRemaining: data.quantityRemaining,
        goodsItemStatus: data.status,
        goodsItemStockCode: data.stockCode,
        goodsItemType: data.type,
        goodsItemUserId: data.userId
      },
      () => {
        console.log(this.state.selectedGoodsItem);
      }
    );
  };

  editGoodsItem = () => {
    if (this.state.goodsItemAdded === true) {
      this.setState({
        editedGoodsItemClientId: "",
        editedGoodsItemDescription: "",
        editedGoodsItemImageURLs: "",
        editedGoodsItemLongDescription: "",
        editedGoodsItemQuantity: "",
        editedGoodsItemQuantityRemaining: "",
        editedGoodsItemStatus: "",
        editedGoodsItemStockCode: "",
        editedGoodsItemType: "",
        editedGoodsItemUserId: ""
      });
    } else {
      this.setState({
        editedGoodsItemClientId: this.state.goodsItemClientId,
        editedGoodsItemDescription: this.state.goodsItemDescription,
        editedGoodsItemImageURLs: this.state.goodsItemImageURLs,
        editedGoodsItemLongDescription: this.state.goodsItemLongDescription,
        editedGoodsItemQuantity: this.state.goodsItemQuantity,
        editedGoodsItemQuantityRemaining: this.state.goodsItemQuantityRemaining,
        editedGoodsItemStatus: this.state.goodsItemStatus,
        editedGoodsItemStockCode: this.state.goodsItemStockCode,
        editedGoodsItemType: this.state.goodsItemType,
        editedGoodsItemUserId: this.state.goodsItemUserId
      });
    }
  };

  reselectGoodsItem = () => {
    if (this.state.selectedGoodsItem) {
      this.state.goodsOrderItems.forEach(e => {
        if (this.state.goodsItemId === e.id) {
          this.setState(
            {
              goodsItemSelected: true,
              goodsItemEdited: false,
              goodsItemAdded: false
            },
            () => {
              this.selectGoodsItem(e);
            }
          );
        }
      });
    }
  };

  checkGoodsItemRequiredFields = () => {
    let disable = false;

    if (this.state.editedGoodsItemStockCode) {
      disable = false;
    } else {
      disable = true;
    }

    return disable;
  };

  generateGoodsInDocket = async () => {
    this.growl.show({
      severity: "warn",
      summary: "Wait",
      detail: "Please wait",
      life: 3000
    });

    let orderRequest = new CloudService.OrderRequestLogistics();
    orderRequest.codeTag = localStorage.getItem("clientId");
    orderRequest.userId = localStorage.getItem("userId");
    orderRequest.id = this.state.goodsId;

    await api("orderApiV1OrderGenerateGoodsReceived", orderRequest).then(
      res => {
        let orderResponse = CloudService.OrderResponseLogistics.constructFromObject(
          res.data
        );
        console.log(orderResponse);

        if (orderResponse.errorCode === 0) {
          this.setState({ goodsPdfURLs: orderResponse.pdfURLs }, () => {
            this.growl.show({
              severity: "success",
              summary: "Success",
              detail: "Pdf successfully generated",
              life: 3000
            });
          });
        } else {
          this.growl.show({
            severity: "error",
            summary: "Error",
            detail: "Pdf failed to generate",
            life: 3000
          });
        }
      }
    );
  };

  dataTableToArray = table => {
    //Get the Id of the DataTable
    let tableId = "";
    if (table.props.id) {
      tableId = table.props.id;
    }

    //Get the Value of the DataTable
    let tableValues = [];
    if (table.props.value) {
      tableValues = JSON.parse(JSON.stringify(table.props.value));
    }
    //console.log(tableValues);

    //Get the Filters of the DataTable
    let tableFilters = [];
    if (table.state.filters) {
      tableFilters = table.state.filters;
    }
    //console.log(tableFilters);

    //Get the Fields of the DataTable
    let tableFields = [];
    if (table.props.children && table.props.children.length) {
      table.props.children.forEach(e => {
        if (e.props.field) {
          tableFields.push(e.props.field.split(".")[0]);
        }
      });
    }
    //console.log(tableFields);

    //Get the Headers of the DataTable
    let tableHeaders = [];
    if (table.props.children && table.props.children.length) {
      table.props.children.forEach(e => {
        tableHeaders.push(e.props.header);
      });
    }
    //console.log(tableHeaders);

    //Get the keys of the Filters and assign to an array
    let extractedFilterKeys = [];
    if (tableFilters) {
      extractedFilterKeys = Object.keys(tableFilters);
    }
    //console.log(extractedFilterKeys);

    //Compare the keys of each Value against the Filter keys
    //Check to see if the Value contains the Filter value
    //Assign the matching Values to an array
    //If no Filters are present map all the Values to the new array
    let filteredList = [];
    if (extractedFilterKeys && extractedFilterKeys.length) {
      tableValues.forEach(e => {
        let extractedValueKeys = Object.keys(e);

        extractedFilterKeys.forEach(f => {
          if (extractedValueKeys.includes(f)) {
            let currentValue = e[f].toLowerCase();
            //console.log(currentValue);
            let currentFilter = table.state.filters[f].value.toLowerCase();
            //console.log(currentFilter);

            if (currentValue.indexOf(currentFilter) !== -1) {
              filteredList.push(e);
            }
          }
        });
      });
    } else {
      filteredList = JSON.parse(JSON.stringify(tableValues));
    }
    //console.log(filteredList);

    //Initialise a new array from the previous array
    //Compare each key of the Values to the Fields of the DataTable
    //If the key doesn't match a Field the Value is removed
    let exactList = [];
    if (filteredList && filteredList.length) {
      exactList = JSON.parse(JSON.stringify(filteredList));

      exactList.forEach(e => {
        let keyList = Object.keys(e);
        keyList.forEach(f => {
          if (tableFields.indexOf(f) === -1) {
            delete e[f];
            //console.log("The key: " + f + " was deleted");
          }
        });
      });
    }
    //console.log(exactList);

    //Initialise a new array of arrays
    //The first array should be created from the DataTable Headers
    let csvList = [[tableHeaders]];

    //In this block the raw data will have to be reformatted to match the DataTable
    //Initialise a new array for the next row
    //If the Field exists pass the Value of the Field to the next row
    //If the Field doesn't exist pass an empty value
    //Pass the array of the next row to the main array
    if (exactList && exactList.length) {
      exactList.forEach(e => {
        if (tableId === "goodsIn") {
          if (e.id) {
            e.id = fo.formatId(e.id);
          }

          if (e.clientDetails) {
            e.clientDetails = e.clientDetails.businessName;
          }
        }

        let nextRow = [];
        tableFields.forEach(f => {
          let keyList = Object.keys(e);
          let nextValue = "";

          keyList.forEach(g => {
            if (f === g) {
              nextValue = e[g];
              //console.log(nextValue)
            }
          });
          nextRow.push(nextValue);
        });
        //console.log(nextRow)

        csvList.push(nextRow);
      });
    }
    //console.log(csvList);

    //Call the function to convert the array to csv
    if (csvList && csvList.length) {
      this.arrayToCSV(csvList);
    }
  };

  arrayToCSV = array => {
    let csvContent =
      "data:text/csv;charset=utf-8," + array.map(e => e.join(",")).join("\n");
    let encodedUri = encodeURI(csvContent);
    var link = document.createElement("a");
    link.setAttribute("href", encodedUri);
    link.setAttribute("download", "goodsIn.csv"); //Declare a csv name here
    document.body.appendChild(link);
    link.click();
  };

  urlsToImages = urlArray => {
    let renderList = [];
    let i = 0;

    if (urlArray && urlArray.length) {
      urlArray.forEach(e => {
        renderList[i] = (
          <center key={i}>
            <img alt="" src={e} />
          </center>
        );
        i++;
      });
    }

    return renderList;
  };

  render() {
    const s = this.state;

    return (
      <div
        className="ui-g dashboard"
        style={s.editLoaded === false ? { pointerEvents: "none" } : {}}
      >
        <pr.Growl style={{ textAlign: "left" }} ref={el => (this.growl = el)} />
        {/*Images*/}
        <pr.Dialog
          header="Delivery Dockets"
          footer={
            <div>
              <pr.Button
                className="secondary-btn"
                label="Close"
                icon="pi pi-times"
                onClick={() => {
                  this.setState({ showImages: false });
                }}
                style={{
                  float: "right"
                }}
              />
            </div>
          }
          visible={s.showImages}
          style={{ width: "80vw" }}
          modal={true}
          onHide={e => this.setState({ showImages: false })}
        >
          <pr.ScrollPanel>
            {this.urlsToImages(s.goodsDeliveryDockets)}
          </pr.ScrollPanel>
        </pr.Dialog>

        {/*Item Images*/}
        <pr.Dialog
          header="Images"
          footer={
            <div>
              <pr.Button
                className="secondary-btn"
                label="Close"
                icon="pi pi-times"
                onClick={() => {
                  this.setState({ showItemImages: false });
                }}
                style={{
                  float: "right"
                }}
              />
            </div>
          }
          visible={s.showItemImages}
          style={{ width: "80vw" }}
          modal={true}
          onHide={e => this.setState({ showItemImages: false })}
        >
          <pr.ScrollPanel>
            {this.urlsToImages(s.goodsItemImageURLs)}
          </pr.ScrollPanel>
        </pr.Dialog>

        {/*Dialog*/}
        <pr.Dialog
          header="Delete Goods"
          footer={
            <div>
              <pr.Button
                className="secondary-btn"
                label="Yes"
                icon="pi pi-check"
                onClick={() => {
                  this.setState({ goodsDeleted: false });
                  this.deleteGoods();
                }}
                style={{
                  float: "right"
                }}
              />
              <pr.Button
                className="secondary-btn"
                label="No"
                icon="pi pi-times"
                onClick={() => {
                  this.setState({ goodsDeleted: false });
                }}
                style={{
                  float: "right"
                }}
              />
            </div>
          }
          visible={s.goodsDeleted}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.setState({ goodsDeleted: false })}
        >
          Are you sure you want to delete?
        </pr.Dialog>

        {/*Item Dialog*/}
        <pr.Dialog
          header="Delete Item"
          footer={
            <div>
              <pr.Button
                className="secondary-btn"
                label="Yes"
                icon="pi pi-check"
                onClick={() => {
                  this.setState({ goodsItemDeleted: false });
                  this.deleteGoodsItem();
                }}
                style={{
                  float: "right"
                }}
              />
              <pr.Button
                className="secondary-btn"
                label="No"
                icon="pi pi-times"
                onClick={() => {
                  this.setState({ goodsItemDeleted: false });
                }}
                style={{
                  float: "right"
                }}
              />
            </div>
          }
          visible={s.goodsItemDeleted}
          style={{ width: "50vw" }}
          modal={true}
          onHide={e => this.setState({ goodsItemDeleted: false })}
        >
          Are you sure you want to delete?
        </pr.Dialog>

        {s.loaded === false ? (
          <LoadScreen />
        ) : s.itemsDisplay === true ? (
          <div className="ui-g-12">
            {/*Item Card*/}
            {s.goodsItemSelected === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Item Id: </b>
                    <label>{fo.formatId(s.goodsItemId)}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Stock Code: </b>
                    <label>{s.goodsItemStockCode || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Name: </b>
                    <label>{s.goodsItemDescription || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Quantity: </b>
                    <label>{s.goodsItemQuantity || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Comment: </b>
                    <label>{s.goodsItemLongDescription || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Images: </b>
                    <br />
                    <pr.Button
                      label="View Images"
                      icon="pi pi-images"
                      onClick={() => {
                        this.setState({ showItemImages: true });
                      }}
                      style={{ width: "50%" }}
                    />
                  </div>
                </div>
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <br />
                </div>
                <div className="ui-g-12">
                  {/* <pr.Button
                    label="Edit"
                    icon="pi pi-plus"
                    onClick={() => {
                      this.setState(
                        {
                          goodsItemSelected: false,
                          goodsItemEdited: true,
                          goodsItemAdded: false
                        },
                        () => {
                          this.editGoodsItem();
                        }
                      );
                    }}
                    style={{ float: "right" }}
                  /> */}
                  {/* <pr.Button
                    label="Delete"
                    icon="pi pi-trash"
                    onClick={() => {
                      this.setState({ goodsItemDeleted: true });
                    }}
                    style={{ float: "right" }}
                  /> */}
                  <pr.Button
                    className="secondary-btn"
                    label="Close"
                    icon="pi pi-times"
                    onClick={() => {
                      this.setState({
                        goodsItemSelected: false,
                        goodsItemEdited: false,
                        goodsItemAdded: false
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Editing Item Card*/}
            {s.goodsItemEdited === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        disabled={true}
                        value={
                          s.goodsItemAdded === true
                            ? "AUTO GENERATED"
                            : fo.formatId(s.goodsItemId)
                        }
                        onChange={() => {}}
                      />
                      <label className="input-label">Item Id</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <label className="input-label">Stock Code *</label>
                    <br />
                    <pr.Dropdown
                      value={s.editedGoodsItemStockCode}
                      options={s.stockCodeOptions}
                      onChange={e => {
                        this.setState(
                          {
                            editedGoodsItemStockCode: e.value
                          },
                          () => {
                            let s = this.state;
                            s.stockList.forEach(e => {
                              if (e.stockCode === s.editedGoodsItemStockCode) {
                                this.setState({
                                  editedGoodsItemDescription: e.description
                                });
                              }
                            });
                          }
                        );
                      }}
                      filter={true}
                      filterBy="label"
                      filterPlaceholder="Search"
                      style={{ marginTop: "1px", width: "100%" }}
                    />
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedGoodsItemDescription || ""}
                        onChange={e => {
                          this.setState({
                            editedGoodsItemDescription: e.target.value
                          });
                        }}
                      />
                      <label className="input-label">Name</label>
                    </span>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedGoodsItemQuantity || ""}
                        onChange={e => {
                          this.setState({
                            editedGoodsItemQuantity: e.target.value
                          });
                        }}
                      />
                      <label className="input-label">Quantity</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedGoodsItemLongDescription || ""}
                        onChange={e => {
                          this.setState({
                            editedGoodsItemLongDescription: e.target.value
                          });
                        }}
                      />
                      <label className="input-label">Comment</label>
                    </span>
                  </div>
                  {s.goodsItemAdded === true ? (
                    <label />
                  ) : (
                    <div className="ui-g-4">
                      <label className="input-label">Images</label>
                      <br />
                      <pr.Button
                        label="View Images"
                        icon="pi pi-images"
                        onClick={() => {
                          this.setState({ showItemImages: true });
                        }}
                        style={{ width: "50%" }}
                      />
                    </div>
                  )}
                </div>
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <br />
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    disabled={this.checkGoodsItemRequiredFields()}
                    label="Save"
                    icon={
                      s.editLoaded === false
                        ? "pi pi-spin pi-spinner"
                        : "pi pi-check"
                    }
                    onClick={() => {
                      s.goodsItemAdded === true
                        ? this.addGoodsItem()
                        : this.updateGoodsItem();
                    }}
                    style={{
                      float: "right"
                    }}
                  />
                  <pr.Button
                    className="secondary-btn"
                    label="Cancel"
                    icon="pi pi-times"
                    onClick={() => {
                      s.goodsItemAdded === true
                        ? this.setState({
                            goodsItemSelected: false,
                            goodsItemEdited: false,
                            goodsItemAdded: false
                          })
                        : this.setState({
                            goodsItemSelected: true,
                            goodsItemEdited: false,
                            goodsItemAdded: false
                          });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Item Table*/}
            <div className="ui-g-12 card">
              <pr.DataTable
                value={s.goodsOrderItems}
                selectionMode="single"
                onSelectionChange={e => {
                  this.setState(
                    {
                      goodsItemSelected: true,
                      goodsItemEdited: false,
                      goodsItemAdded: false
                    },
                    () => {
                      this.selectGoodsItem(e.data);
                    }
                  );
                }}
                selection={s.selectedGoodsItem}
                header={
                  <div className="ui-g">
                    <div className="ui-g-12">
                      {/* <pr.Button
                        className="secondary-btn"
                        label="Create New"
                        icon="pi pi-pencil"
                        onClick={() => {
                          this.setState(
                            {
                              goodsItemSelected: false,
                              goodsItemEdited: true,
                              goodsItemAdded: true,
                              selectedGoodsItem: ""
                            },
                            () => {
                              this.editGoodsItem();
                            }
                          );
                        }}
                        style={{ float: "right" }}
                      /> */}
                      <pr.Button
                        className="secondary-btn"
                        label="Back"
                        icon="pi pi-arrow-left"
                        onClick={() => {
                          this.setState({
                            goodsItemSelected: false,
                            goodsItemEdited: false,
                            goodsItemAdded: false,
                            selectedGoodsItem: "",
                            itemsDisplay: false
                          });
                        }}
                        style={{ float: "right" }}
                      />
                    </div>
                    <div className="ui-g-12">
                      <label className="header-label">Goods Items</label>
                    </div>
                  </div>
                }
                emptyMessage="No Goods Items"
                rows={100}
                autoLayout={true}
                paginator={true}
                alwaysShowPaginator={true}
              >
                <pr.Column
                  field="id"
                  header="Item Id"
                  body={e => {
                    return fo.formatId(e.id);
                  }}
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="stockCode"
                  header="Stock Code"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="description"
                  header="Name"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="quantity"
                  header="Quantity"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="quantityRemaining"
                  header="Quantity Remaining"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="longDescription"
                  header="Comment"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
              </pr.DataTable>
            </div>
          </div>
        ) : (
          /*Split*/
          <div className="ui-g-12">
            {/*Card*/}
            {s.goodsSelected === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Goods Id: </b>
                    <label>{fo.formatId(s.goodsId)}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Goods Number: </b>
                    <label>{s.goodsDnumber || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Client: </b>
                    <label>
                      {s.goodsClientDetailsBusinessName || "Not Set"}
                    </label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Date Order Received: </b>
                    <label>
                      {s.goodsDateOrderReceivedToDisplay || "Not Set"}
                    </label>
                  </div>
                  <div className="ui-g-4">
                    <b>Collected By: </b>
                    <label>{s.goodsCollectedBy || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Delivery Driver Name: </b>
                    <label>{s.goodsDeliveryDriverName || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Delivery Driver Signature: </b>
                  </div>
                  <div className="ui-g-4">
                    {s.goodsDeliveryDriverSignature ? (
                      <img
                        src={s.goodsDeliveryDriverSignature}
                        alt=""
                        style={{
                          width: "20%"
                        }}
                      />
                    ) : (
                      <label>Not Set</label>
                    )}
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>S/O Number: </b>
                    <label>{s.goodsSoNumber || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Type: </b>
                    <label>{s.goodsType || "Not Set"}</label>
                  </div>
                  <div className="ui-g-4">
                    <b>Status: </b>
                    <label>{s.goodsStatus || "Not Set"}</label>
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <b>Delivery Dockets: </b>
                    <br />
                    <pr.Button
                      label="View Images"
                      icon="pi pi-images"
                      onClick={() => {
                        this.setState({ showImages: true });
                      }}
                      style={{ width: "50%" }}
                    />
                  </div>
                  <div className="ui-g-4">
                    <b>Goods In Docket: </b>
                    <br />
                    <a href={s.goodsPdfURLs}>
                      <pr.Button
                        label="Download PDF"
                        icon="pi pi-download"
                        style={{ width: "50%" }}
                      />
                    </a>
                  </div>
                </div>
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <br />
                </div>
                <div className="ui-g-12">
                  {/* <pr.Button
                    label="Edit"
                    icon="pi pi-plus"
                    onClick={() => {
                      this.setState(
                        {
                          goodsSelected: false,
                          goodsEdited: true,
                          goodsAdded: false
                        },
                        () => {
                          this.editGoods();
                        }
                      );
                    }}
                    style={{ float: "right" }}
                  /> */}
                  {/* <pr.Button
                    label="Delete"
                    icon="pi pi-trash"
                    onClick={() => {
                      this.setState({ goodsDeleted: true });
                    }}
                    style={{ float: "right" }}
                  /> */}
                  <pr.Button
                    label="Generate Goods In Docket"
                    icon="pi pi-file"
                    onClick={() => {
                      this.generateGoodsInDocket();
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    className="secondary-btn"
                    label="View Items"
                    icon="pi pi-list"
                    onClick={() => {
                      this.setState({
                        itemsDisplay: true
                      });
                    }}
                    style={{ float: "right" }}
                  />
                  <pr.Button
                    className="secondary-btn"
                    label="Close"
                    icon="pi pi-times"
                    onClick={() => {
                      this.setState({
                        goodsSelected: false,
                        goodsEdited: false,
                        goodsAdded: false
                      });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Editing Card*/}
            {s.goodsEdited === false ? (
              <label />
            ) : (
              <div className="ui-g-12 card">
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <label />
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        disabled={true}
                        value={
                          s.goodsAdded === true
                            ? "AUTO GENERATED"
                            : fo.formatId(s.goodsId)
                        }
                        onChange={() => {}}
                      />
                      <label className="input-label">Goods Id</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        disabled={s.goodsAdded}
                        value={
                          s.goodsAdded === true
                            ? "AUTO GENERATED"
                            : s.editedGoodsDnumber || ""
                        }
                        onChange={e => {
                          this.setState({ editedGoodsDnumber: e.target.value });
                        }}
                      />
                      <label className="input-label">Goods Number</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <label className="input-label">Client *</label>
                    <br />
                    <pr.Dropdown
                      value={s.editedGoodsClientId}
                      options={s.clientOptions}
                      onChange={e => {
                        this.setState({
                          editedGoodsClientId: e.value
                        });
                      }}
                      filter={true}
                      filterBy="label"
                      filterPlaceholder="Search"
                      style={{ marginTop: "1px", width: "100%" }}
                    />
                  </div>
                </div>
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <label className="input-label">Date Order Received</label>
                    <br />
                    <pr.Calendar
                      value={s.editedGoodsDateOrderReceived}
                      onChange={e =>
                        this.setState({ editedGoodsDateOrderReceived: e.value })
                      }
                      dateFormat={s.dateFormat}
                    />
                  </div>
                  <div className="ui-g-4">
                    <label className="input-label">Collected By</label>
                    <br />
                    <pr.Dropdown
                      value={s.editedGoodsCollectedBy}
                      options={c.goodsCollectedByOptions}
                      onChange={e => {
                        this.setState({
                          editedGoodsCollectedBy: e.value
                        });
                      }}
                      filter={false}
                      filterBy="label"
                      filterPlaceholder="Search"
                      style={{ marginTop: "1px", width: "100%" }}
                    />
                  </div>
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedGoodsDeliveryDriverName || ""}
                        onChange={e => {
                          this.setState({
                            editedGoodsDeliveryDriverName: e.target.value
                          });
                        }}
                      />
                      <label className="input-label">
                        Delivery Driver Name
                      </label>
                    </span>
                  </div>
                </div>
                {s.goodsAdded === true ? (
                  <label />
                ) : (
                  <div className="ui-g-12">
                    <div className="ui-g-4">
                      <label className="input-label">
                        Delivery Driver Signature
                      </label>
                    </div>
                    <div className="ui-g-4">
                      {s.goodsDeliveryDriverSignature ? (
                        <img
                          src={s.goodsDeliveryDriverSignature}
                          alt=""
                          style={{
                            width: "20%"
                          }}
                        />
                      ) : (
                        <label>Not Set</label>
                      )}
                    </div>
                  </div>
                )}
                <div className="ui-g-12">
                  <div className="ui-g-4">
                    <span className="md-inputfield form-field">
                      <pr.InputText
                        value={s.editedGoodsSoNumber || ""}
                        onChange={e => {
                          this.setState({
                            editedGoodsSoNumber: e.target.value
                          });
                        }}
                      />
                      <label className="input-label">S/O Number</label>
                    </span>
                  </div>
                  <div className="ui-g-4">
                    <label className="input-label">Type</label>
                    <br />
                    <pr.Dropdown
                      value={s.editedGoodsType}
                      options={c.typeOptions}
                      onChange={e => {
                        this.setState({
                          editedGoodsType: e.value
                        });
                      }}
                      filter={false}
                      filterBy="label"
                      filterPlaceholder="Search"
                      style={{ marginTop: "1px", width: "100%" }}
                    />
                  </div>
                  <div className="ui-g-4">
                    <label className="input-label">Status</label>
                    <br />
                    <pr.Dropdown
                      value={s.editedGoodsStatus}
                      options={c.goodsStatusOptions}
                      onChange={e => {
                        this.setState({
                          editedGoodsStatus: e.value
                        });
                      }}
                      filter={false}
                      filterBy="label"
                      filterPlaceholder="Search"
                      style={{ marginTop: "1px", width: "100%" }}
                    />
                  </div>
                </div>
                {s.goodsAdded === true ? (
                  <label />
                ) : (
                  <div className="ui-g-12">
                    <div className="ui-g-4">
                      <label className="input-label">Delivery Dockets</label>
                      <br />
                      <pr.Button
                        label="View Images"
                        icon="pi pi-images"
                        onClick={() => {
                          this.setState({ showImages: true });
                        }}
                        style={{ width: "50%" }}
                      />
                    </div>
                    <div className="ui-g-4">
                      <label className="input-label">Goods In Docket</label>
                      <br />
                      <a href={s.goodsPdfURLs}>
                        <pr.Button
                          label="Download PDF"
                          icon="pi pi-download"
                          style={{ width: "50%" }}
                        />
                      </a>
                    </div>
                  </div>
                )}
                <div className="ui-g-12">
                  {/*Empty div for spacing*/}
                  <br />
                </div>
                <div className="ui-g-12">
                  <pr.Button
                    disabled={this.checkGoodsRequiredFields()}
                    label="Save"
                    icon={
                      s.editLoaded === false
                        ? "pi pi-spin pi-spinner"
                        : "pi pi-check"
                    }
                    onClick={() => {
                      s.goodsAdded === true
                        ? this.addGoods()
                        : this.updateGoods();
                    }}
                    style={{
                      float: "right"
                    }}
                  />
                  <pr.Button
                    className="secondary-btn"
                    label="Cancel"
                    icon="pi pi-times"
                    onClick={() => {
                      s.goodsAdded === true
                        ? this.setState({
                            goodsSelected: false,
                            goodsEdited: false,
                            goodsAdded: false
                          })
                        : this.setState({
                            goodsSelected: true,
                            goodsEdited: false,
                            goodsAdded: false
                          });
                    }}
                    style={{ float: "right" }}
                  />
                </div>
              </div>
            )}

            {/*Table*/}
            <div className="ui-g-12 card">
              <pr.DataTable
                ref={el => {
                  this.dt = el;
                }}
                id="goodsIn"
                value={s.goodsList}
                selectionMode="single"
                onSelectionChange={e => {
                  this.setState(
                    {
                      goodsSelected: true,
                      goodsEdited: false,
                      goodsAdded: false
                    },
                    () => {
                      this.selectGoods(e.data);
                    }
                  );
                }}
                selection={s.selectedGoods}
                header={
                  <div className="ui-g">
                    <div className="ui-g-12">
                      {/* <pr.Button
                        className="secondary-btn"
                        label="Create New"
                        icon="pi pi-pencil"
                        onClick={() => {
                          this.setState(
                            {
                              goodsSelected: false,
                              goodsEdited: true,
                              goodsAdded: true,
                              selectedGoods: ""
                            },
                            () => {
                              this.editGoods();
                            }
                          );
                        }}
                        style={{ float: "right" }}
                      /> */}
                      <pr.Button
                        className="secondary-btn"
                        label="Download CSV"
                        icon="pi pi-download"
                        onClick={() => {
                          this.dataTableToArray(this.dt);
                        }}
                        style={{ float: "left" }}
                      />
                    </div>
                    <div className="ui-g-12">
                      <label className="header-label">Goods In</label>
                    </div>
                  </div>
                }
                emptyMessage="No Goods"
                //rows={100}
                autoLayout={true}
                paginator={true}
                alwaysShowPaginator={true}
              >
                <pr.Column
                  field="id"
                  header="Goods Id"
                  body={e => {
                    return fo.formatId(e.id);
                  }}
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="dnumber"
                  header="Goods Number"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="clientDetails.businessName"
                  header="Client"
                  body={e => {
                    if (e.clientDetails) {
                      return e.clientDetails.businessName;
                    }
                  }}
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="dateOrderReceivedToDisplay"
                  header="Date Received"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="totalQuantity"
                  header="Quantity"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="quantityRemaining"
                  header="Quantity Remaining"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="type"
                  header="Type"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
                <pr.Column
                  field="status"
                  header="Status"
                  sortable={true}
                  filter={true}
                  filterMatchMode="contains"
                  style={{ overflow: "auto" }}
                />
              </pr.DataTable>
            </div>
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/Goods/GoodsComplete.js